import React from 'react';
import { ReactComponent as EtherscanIcon } from '@blink/assets/src/icons/etherscan.svg';

import { Button, ButtonSize, ButtonVariant } from '../Button';

interface ViewOnEtherscanButtonProps {
    resource: { address: string } | { tx: string };
    size?: ButtonSize;
    variant?: ButtonVariant;
    className?: string;
}

export const ViewOnEtherscanButton: React.FC<ViewOnEtherscanButtonProps> = ({
    resource = { address: '' },
    size = ButtonSize.Medium,
    variant = ButtonVariant.Link,
    className = '',
}) => {
    const path = 'address' in resource ? `address/${resource.address}` : `tx/${resource.tx}`;
    const handleClick = () => {
        const url = `https://etherscan.io/${path}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Button size={size} variant={variant} className={className} onClick={handleClick}>
            <EtherscanIcon className='mr-2' />
            <span>View on Etherscan</span>
        </Button>
    );
};
